<template>
  <div class="player-card">
    <div class="player-avatar">
      <i
        :class="player.gender === 'male' ? 'fas fa-user' : 'fas fa-user-alt'"
      ></i>
    </div>
    <div class="player-name">{{ player.name }}</div>
  </div>
</template>

<script>
export default {
  name: "PlayerCard",
  props: {
    player: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
.player-card {
  background-color: var(--card-bg);
  border-radius: var(--border-radius-md);
  padding: var(--spacing-md);
  text-align: center;
  animation: fadeIn var(--transition-normal);
}

.player-avatar {
  font-size: 1.8rem;
  margin-bottom: var(--spacing-sm);
  color: var(--accent-color);
}

.player-name {
  font-weight: 500;
}
</style>
